<template>
  <div class="flex items-center gap-4 mr-4">
    <p
      @click="toggleMenu"
      v-if="!menuVisible"
      class="cursor-pointer px-1 button-class"
    >
      {{ currentLanguageLabel }}
    </p>
    <ul v-if="menuVisible" class="language-options gap-2">
      <li
        v-for="lang in languages"
        :key="lang.code"
        @click="changeLanguage(lang.code)"
        :class="{
          'text-current': lang.code === $store.state.currentLanguage,
          'text-nocurrent': lang.code !== $store.state.currentLanguage,
        }"
        class="cursor-pointer"
      >
        {{ lang.label }}
      </li>
    </ul>
    <div>
      <label class="switch">
        <span class="sun"
          ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <g fill="--text-color">
              <circle r="5" cy="12" cx="12"></circle>
              <path
                d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"
              ></path>
            </g></svg
        ></span>
        <span class="moon"
          ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
            <path
              d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
            ></path></svg
        ></span>
        <input
          type="checkbox"
          class="input"
          @click="toggleDarkMode"
          :checked="isDarkModeChecked"
        />
        <span class="slider"></span>
      </label>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      menuVisible: false,
      languages: [
        { code: "ca", label: "cat" },
        { code: "es", label: "cast" },
        { code: "en", label: "en" },
      ],
      isDarkModeChecked: false,
    };
  },
  computed: {
    currentLanguageLabel() {
      // Devuelve la etiqueta del idioma actual
      const current = this.languages.find(
        (lang) => lang.code === this.$store.state.currentLanguage
      );
      return current ? current.label : "cat";
    },
    isDarkMode() {
      return this.$store.state.isDarkMode;
    },
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    changeLanguage(lang) {
      this.$store.commit("setLanguage", lang);
      this.menuVisible = false;
    },
    toggleDarkMode() {
      this.$store.commit("toggleDarkMode");
      this.isDarkModeChecked = this.$store.state.isDarkMode;
    },
  },
  created() {
    // Inicializa el estado del toggle según el modo almacenado
    this.isDarkModeChecked = this.$store.state.isDarkMode;
  },
};
</script>

<style scoped>
.switch {
  font-size: 15px;
  position: relative;
  display: inline-block;
  width: 45px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--background-color);
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.19);
  transition: 0.4s;
  border-radius: 30px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  border-radius: 20px;
  left: 2px;
  bottom: 2px;
  z-index: 2;
  background-color: var(--text-color);
  transition: 0.4s;
}

.sun svg {
  position: absolute;
  top: 3px;
  left: 24px;
  z-index: 1;
  width: 18px;
  height: 18px;
}

.moon svg {
  fill: var(--text-color);
  position: absolute;
  top: 3px;
  left: 5px;
  z-index: 1;
  width: 17px;
  height: 17px;
}

/* .switch:hover */
.sun svg {
  animation: rotate 15s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* .switch:hover */
.moon svg {
  animation: tilt 5s linear infinite;
}

@keyframes tilt {
  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-10deg);
  }

  75% {
    transform: rotate(10deg);
  }

  100% {
    transform: rotate(0deg);
  }
}

.input:checked + .slider {
  background-color: var(--background-color);
  box-shadow: 0 2px 20px 0 rgba(197, 195, 195, 0.19);
}

.input:focus + .slider {
  box-shadow: 0 0 1px #183153;
}

.input:checked + .slider:before {
  transform: translateX(21px);
}

.button-class {
  background-color: var(--background-color);
  border-radius: 20px;
  padding: 0px 5px;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.19);
}

.button-class:hover {
  opacity: 70%;
}

.text-current {
  color: var(--text-color);
  text-align: center;
}

.text-nocurrent {
  opacity: 60%;
  color: var(--text-color);
  text-align: center;
}

.text-nocurrent:hover {
  opacity: 100%;
}

.language-options {
  background-color: var(--background-color);
  border-radius: 10px;
  padding: 0px 5px;
  justify-content: center;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.19);
}
</style>
